module.exports = __webpack_public_path__ + "img/card-5AF2EC.5108a90c.png";